import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Edits the CURRENT URL's search params in place (replace, no history entry).
 *
 * react-router's `setSearchParams` — updater form included — starts from the
 * params of the caller's last render, so two writers in one tick clobber each
 * other: Creator Studio's `videoId` sync used to drop a `lang` written 8ms
 * earlier (PLAT-11898). Reading `window.location` at call time sees both.
 * That is the router's URL under `createBrowserRouter`; a test's
 * `MemoryRouter` has its own, so tests seed the window URL to match.
 */
export function useUpdateSearchParams(): (
  mutate: (params: URLSearchParams) => void,
) => void {
  const navigate = useNavigate();
  return useCallback(
    mutate => {
      const params = new URLSearchParams(window.location.search);
      mutate(params);
      navigate({ search: params.toString() }, { replace: true });
    },
    [navigate],
  );
}
